class ComponentSearch extends HTMLElement {
  constructor() {
    super();
    this.searchField = this.querySelector('input[name="q"]');
    this.results = this.querySelector('.search-results');
    this.form = this.querySelector('form');
    this.searchDelay = 300;
    this.searchType = 'product';
    this.controller = null;
    this.requestTimeout = 0;

    if (this.dataset.autocomplete == "true") {
      this.documentClickHandler = this.documentClick.bind(this);
      this.searchField.addEventListener('input', this.doSearch.bind(this));
    }

    this.form.addEventListener('submit', (e)=>{
      e.preventDefault();
      const formData = new FormData(this.form);
      const searchParams = new URLSearchParams(formData);
      const query = searchParams.get('q');
      if(query && query!="") {
        searchParams.set('q', '*'+query+'*');
        location = this.form.action + '?' + searchParams.toString();
      }
    });
  }

  //term param allows to trigger custom search from js code.
  doSearch(term) {
    term = typeof(term)=="string" ? term : '*'+this.searchField.value.trim()+'*';
    if (this.controller) {
      this.controller.abort();
      this.controller = null;
    }
    clearTimeout(this.requestTimeout);
    if (term.length>=5) {
      this.showSearchingResults();
      this.requestTimeout = setTimeout(()=>{
        this.controller = new AbortController();
        $s.getJson({
          signal: this.controller.signal,
          url: '/search?view=ajax_json&type='+ this.searchType +'&q='+ encodeURIComponent(term),
          success: (response)=>{
            this.clearResults(false);
            if (response.results_count > 0) {
              var title = document.createElement('div'); 
              title.innerHTML = "Search results"; //title for screen reader
              title.classList.add('visually-hidden');
              this.results.appendChild(title);
              response.results.forEach((item)=>{
                this.results.appendChild(this.buildItem(item));
              });
              if (response.results_count > response.results.length) {
                var linkUrl = '/search?type='+ this.searchType +'&q='+ encodeURIComponent(term);
                this.results.appendChild(this.buildSeeAllLink(linkUrl, response.results_count));
              }
            } else {
              this.noResults();
            }
          }
        });
      }, this.searchDelay);
    } else {
      this.clearResults();
    }
  }

  buildItem(itemJson) {
    var img = document.createElement('img');
    var title = document.createElement('div');
    var a = document.createElement('a');
    a.classList.add("item", "flex", "flex-1", "direction-row", "justify-content-start", "align-items-center");
    a.href = itemJson.url;
    img.src = itemJson.thumbnail;
    img.alt = '';
    title.innerHTML = itemJson.title;
    a.appendChild(img);
    a.appendChild(title);
    return a;
  }

  buildSeeAllLink(url, resultsQuantity) {
    var a = document.createElement('a');
    a.classList.add('see-all');
    a.href = url;
    a.innerHTML = 'See all ' + resultsQuantity + ' results';
    return a;
  }

  showSearchingResults() {
    if (!this.results.style.minHeight) {
      document.addEventListener('click', this.documentClickHandler);

      var height = this.results.offsetHeight;
      this.results.style.minHeight = Math.max(height, 80)  + 'px';
      this.results.innerHTML = '<div style="height: 100%;" class="loader-wrap flex justify-content-center align-items-center"><div class="loader" style="border-top-color: #ccc;"></div></div>';
    }
  }

  clearResults(removeEvents=true) {
    if(removeEvents) {
      document.removeEventListener('click', this.documentClickHandler);
    }
    this.results.innerHTML = '';
    this.results.style.minHeight = '';
  }

  noResults() {
    this.results.innerHTML = '<div class="no-results">No results</div>';
  }

  documentClick(e) {
    if(!this.contains(e.target)) {
      this.clearResults();
    }
  }
}
customElements.define('search-form', ComponentSearch);